<!--意见反馈记录页面-->
<template>
  <div class="record">
    <a-spin :spinning="applySpinning">
      <div>
        <a-table
          ref="tabRef"
          size="small"
          bordered
          :scroll="{ x: 1000, y: true }"
          :rowKey="record => record.fbId"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="false"
          :loading="loading"
        >
          <template slot="action" slot-scope="text, record, index">
            <a @click="gotoDetail(record.fbId)">详情</a>
            <!-- <sapn v-if="record.status == 0">
              <a-popconfirm
                title="确定撤销反馈吗?"
                @confirm="() => handleCancel(record.fbId)"
              >
                <a>撤销</a>
              </a-popconfirm>
            </sapn> -->
          </template>
        </a-table>
      </div>
      <div class="pagination">
        <a-pagination
          show-quick-jumper
          :default-current="1"
          :total="total"
          :current="pageNo"
          :pageSize="pageSize"
          @change="onChange"
        />
      </div>
    </a-spin>

    <a-modal
      title="反馈详情"
      :visible="visible"
      @cancel="visible = false"
      width="800px"
      :maskClosable="false"
      :bodyStyle="{ padding: '16px' }"
      :okButtonProps="{ style: { display: 'none' } }"
    >
      <div class="detail_div">
        <a-descriptions title="" bordered size="middle">
          <a-descriptions-item label="反馈类型">
            {{ typeMap[detail.leaveType] }}
          </a-descriptions-item>
          <a-descriptions-item label="反馈时间" :span="2">
            {{ detail.createTime }}
          </a-descriptions-item>
          <a-descriptions-item label="联系电话">
            {{ detail.fbPhone }}
          </a-descriptions-item>
          <a-descriptions-item label="联系邮箱" :span="2">
            {{ detail.fbEmail }}
          </a-descriptions-item>
          <a-descriptions-item label="反馈内容" :span="3">
            <div style="flex-wrap: wrap;word-break: break-all;max-width:600px;">
              {{ detail.fbContent }}
            </div>
          </a-descriptions-item>
          <a-descriptions-item label="附加图片" :span="3">
            <ul style="display: flex;overflow-wrap: normal;">
              <li v-for="item of detail.fileList">
                <a @click="downloadOrPreview(item, '')">
                  <img
                    :src="item"
                    style="max-height: 60px;max-width: 60px;margin-right: 5px;"
                  />
                </a>
              </li>
            </ul>
          </a-descriptions-item>
          <a-descriptions-item label="反馈状态" :span="3">
            {{ statusMap[detail.status] }}
          </a-descriptions-item>
          <a-descriptions-item label="回复人">
            {{ detail.repName }}
          </a-descriptions-item>
          <a-descriptions-item label="回复时间" :span="2">
            {{ detail.replydate }}
          </a-descriptions-item>
          <a-descriptions-item label="回复内容">
           

             <div style="flex-wrap: wrap;word-break: break-all;max-width:600px;">
              {{ detail.repContent }}
            </div>
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: "record",
  data() {
    return {
      description: "学生反馈记录",
      dataSource: [],
      loading: false,
      columns: [
        {
          title: "#",
          dataIndex: "",
          key: "rowIndex",
          width: 60,
          align: "center",
          customRender: (t, r, index) => {
            return parseInt(index) + 1;
          }
        },
        {
          title: "反馈类型",
          dataIndex: "leaveType",
          align: "center",
          ellipsis: true,
          width: 100,
          customRender: text => {
            return this.typeMap[text];
          }
        },
        {
          title: "反馈内容",
          dataIndex: "fbContent",
          align: "left",
          ellipsis: true,
          width: 200
        },
        {
          title: "反馈电话",
          dataIndex: "fbPhone",
          align: "center",
          ellipsis: true,
          width: 130
        },
        {
          title: "反馈时间",
          dataIndex: "createTime",
          align: "center",
          ellipsis: true,
          width: 150
        },
        {
          title: "反馈状态",
          dataIndex: "status",
          align: "center",
          ellipsis: true,
          width: 100,
          customRender: text => {
            return this.statusMap[text];
          }
        },
        {
          title: "回复人姓名",
          dataIndex: "repName",
          align: "center",
          ellipsis: true,
          width: 100
        },
        {
          title: "回复时间",
          dataIndex: "replydate",
          align: "center",
          ellipsis: true,
          width: 150
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          fixed: "right",
          width: 100,
          // slots: { customRender: "action" }
          scopedSlots: { customRender: "action" }
        }
      ],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      detail: {},
      applySpinning: false,
      typeMap: {
        1: "学籍",
        2: "教务",
        3: "考务",
        4: "论文",
        5: "学位外语",
        0: "其它"
      },
      statusMap: {
        0: "待回复",
        1: "已回复",
        2: "已撤销"
      },
      visible: false,
      currentId: ""
    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    // 查询反馈记录列表
    getDataList() {
      const params = {
        type: "0",
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      this.applySpinning = true;
      this.axios
        .get(`/biz/user/feedback/list`, {
          params
        })
        .then(res => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.total = res.result.total;
          }
        })
        .finally(() => {
          this.applySpinning = false;
        });
    },
    // 查询反馈详情
    getDetail(id) {
      this.detail = {};
      const params = { id };
      this.axios.get(`/biz/user/feedback/detail?id=${id}`).then(res => {
        if (res.success) {
          this.detail = res.result;
          if (res.result.urls) {
            this.detail.fileList = res.result.urls.split(",");
          }
        }
      });
    },
    // 反馈撤销
    handleCancel(id) {
      this.axios.get(`/biz/user/feedback/cancel?id=${id}`).then(res => {
        if (res.success) {
          this.getDataList();
          this.$message.success(res.message);
        }
      });
    },
    // 分页跳转
    onChange(index) {
      this.pageNo = index;
      this.getDataList();
    },
    // 查询反馈详情
    gotoDetail(id) {
      this.currentId = id;
      this.visible = true;
      this.getDetail(id);
    },

    // 下载或预览文件
    downloadOrPreview(url, filename) {
      if (!url) return;
      const dotIndex = url.lastIndexOf(".");
      if (dotIndex === -1) return "";
      const extension = url.substring(dotIndex + 1).toLowerCase();
      if (this.isImageFile(extension)) {
        // 图片文件直接打开
        window.open(url, "_blank");
      } else {
        // 其他文件下载
        if (!filename) {
          filename = this.getFilenameFromUrl(url);
        }
        this.downloadFile(url, filename);
      }
    },
    // 判断是否图片文件
    isImageFile(extension) {
      const imageExtensions = [
        "bmp",
        "jpg",
        "jpeg",
        "png",
        "gif",
        "svg",
        "webp",
        "BMP",
        "JPG",
        "JPEG",
        "PNG",
        "GIF",
        "SVG",
        "tiff",
        "ico",
        "pdf",
        "PDF",
        "txt",
        "TXT"
      ];
      return imageExtensions.includes(extension);
    },
    // 获取文件名
    getFilenameFromUrl(url) {
      if (!url) return "";
      const cleanUrl = url.split("?")[0].split("#")[0];
      return cleanUrl.split("/").pop();
    },
    // 附件下载
    downloadFile(url, name) {
      this.axios
        .get(url, {
          responseType: "blob"
        })
        .then(res => {
          const url = window.URL.createObjectURL(res);
          const el = document.createElement("a");
          el.setAttribute("href", url);
          el.setAttribute("download", name);
          el.style.display = "none";
          document.body.appendChild(el);
          el.click();
          document.body.removeChild(el);
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';
.record {
    padding: 28px;
    margin-top: 20px;
    background-color #fff
}
.pagination {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 30px 0;
  }
  .detail{
    color: $bgColor;
    cursor: pointer;
  }
  .file-item-box {
    display: flex;
    gap : 10px;
  }
  .detail_div {
    /deep/ .ant-descriptions-item-label {
      width: 110px;
      text-align: right;
    }
    /deep/ .ant-descriptions-item-content {
      min-width: 180px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/feedback/record.vue